module.exports = __webpack_public_path__ + "img/Frame.4a7d4553.png";